import { useState } from "react";

import "./stylesGlobalChatModal.css";

import BlockUserIcon from "../../../../../assets/icons/ic_block-user.svg";

import { CloseOutlined } from "@ant-design/icons";

import { Input, Select } from "antd";
import { AppStrings } from "../../../../../utils/constants/AppStrings";
import {
  getApiErrorMessage,
  getApiSuccessMessage,
} from "../../../../../utils/ErrorUtils";
import ToggleSwitch from "../../../../CommonComponents/ToggleSwitch/ToggleSwitch";
import createPrivateAdminPanelInstance from "../../../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../../../api/ApiRoutes";
import { message } from "antd";
import RebetLoader from "../../../../CommonComponents/RebetLoader/RebetLoader";

function GlobalChatModal({ handleCancel, data, refreshUserData }) {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
    false
  );

  const [globalChatEnabled, setGlobalChatEnabled] = useState(
    data?.global_chat_enabled ?? true
  );
  const [isApiRunning, setIsApiRunning] = useState(false);

  const onCancel = () => {
    handleCancel();
  };

  const handleGlobalChatChange = (checked) => {
    setGlobalChatEnabled(checked.is_active);
  };

  const onSave = async (updatedFlag) => {
    setIsApiRunning(true);
    const updatedOption = updatedFlag.is_active;

    const payload = {
      global_chat_enabled: updatedOption,
    };

    try {
      const res = await PrivateAdminPanelInstance.patch(
        API_ROUTES.UPDATE_USER_GLOBAL_CHAT_STATUS.replace(
          "{user_id}",
          data.user_id
        ),
        payload
      );

      await refreshUserData({ global_chat_enabled: updatedOption });

      setGlobalChatEnabled(updatedOption);
      message.success(
        getApiSuccessMessage(res, AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED)
      );
    } catch (error) {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
      console.error("Update error:", error);
    } finally {
      setIsApiRunning(false);
    }
  };

  return (
    <div className="global-chat-modal-container">
      <div className="modal-header">
        <div className="modal-header-title">
          <h2 className="modal-title"> {AppStrings.GLOBAL_CHAT_TOGGLE}</h2>
        </div>
        <CloseOutlined onClick={handleCancel} className="close-icon" />
      </div>

      <div className="modal-content">
        <div className="modal-content-title">
          <span>
            {AppStrings.USER}: {data.username}
          </span>
        </div>
        <div className="transaction-info-item">
          <span>{AppStrings.GLOBAL_CHAT_ENABLED}?</span>
          <div className="global-chat-toggle-container">
            <span
              className={`global-chat-toggle-status ${
                globalChatEnabled ? "enabled" : "disabled"
              }`}
            >
              {globalChatEnabled ? "Yes" : "No"}
            </span>
            <ToggleSwitch
              status={globalChatEnabled}
              onChange={handleGlobalChatChange}
              updateEventCode={onSave}
              data={data}
            />
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <div className="buttons">
          <button
            className="cancel-button"
            onClick={onCancel}
            disabled={isApiRunning}
          >
            {AppStrings.CLOSE}
          </button>
          <button className="save-button" disabled={isApiRunning}>
            {isApiRunning ? (
              <RebetLoader height={"20px"} width={"20px"} />
            ) : (
              AppStrings.SAVE
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GlobalChatModal;
